import React, { useEffect, useState } from "react";
import ModalOverlay from "../ModalOverlay";
import { enableScroll, disableScroll } from "@assets/js/scrolllock";
import ActionButton from "../ActionButton";
import { useInvoice, useMyFritzHansenInvoiceModal } from "@store/myfritzhansen";
import { useTranslation } from "react-i18next";

const MyFritzHansenInvoiceModal = () =>{
    const [modalActive, setModalActive] = useState(false);
    const [showMyFritzHansenInvoiceModal, setShowMyFritzHansenInvoiceModal] = useMyFritzHansenInvoiceModal();
    const [deleteInvoice,,invoiceToBeDeleted,setInvoiceToBeDelted] = useInvoice();
    const { t } = useTranslation();

    const texts = {
        yes: t("FritzHansen_Project_ConsumersAndProfessionals_PDP_Yes"),
        no: t("FritzHansen_Project_ConsumersAndProfessionals_PDP_No"),
        title: t("FritzHansen_Project_ConsumersAndProfessionals_MyFritzHansen_DeleteInvoiceModal_Title"),
        text: t("FritzHansen_Project_ConsumersAndProfessionals_MyFritzHansen_DeleteInvoiceModal_Text"),
      };    
    const cancelButtonHandler = () => {
        setShowMyFritzHansenInvoiceModal(false);
        setModalActive(false);
        enableScroll();
        setInvoiceToBeDelted("");
    };

    const deleteButtonHandler = () =>{
        deleteInvoice(true,invoiceToBeDeleted);
        setModalActive(false);
        enableScroll();
        setInvoiceToBeDelted("");
        setShowMyFritzHansenInvoiceModal(false);
    }

    useEffect(() => {
        if (showMyFritzHansenInvoiceModal) {
            setModalActive(true);
            disableScroll();
        }
    }, [showMyFritzHansenInvoiceModal]);

    return (
        <ModalOverlay
            className="qrcode-modal"
            openState={modalActive}
            closeHandler={cancelButtonHandler}
            content={
                <>
                    <h3>{texts.title}</h3>
                    <p className="text">{texts.text}</p>
                    <div className="button-modal">
                        <ActionButton
                            text={texts.yes}
                            buttonType="ghost"
                            isDisabled={false}
                            clickHandler={deleteButtonHandler}
                        />
                        <ActionButton
                            text={texts.no}
                            buttonType="ghost"
                            isDisabled={false}
                            clickHandler={cancelButtonHandler}
                        />
                    </div>
                </>
                
            }
        />
    );
}

export default MyFritzHansenInvoiceModal